export enum StoreName {
  ActivityLog = 'activitylog',
  TimeRecord = 'timerecord',
  Project = 'project',
  Task = 'task',
  LaborCategory = 'laborcategory',
  FIPSState = 'fipsstate',
  User = 'user',
  Activity = 'activity',
  FieldActivity = 'fieldactivity',
  Users2FieldActivity = 'users2fieldactivity',
  CurrentWorkAssignment = 'currentworkassignment',
  Photo = 'photo',
  Incident = 'incident',
  IncidentType = 'incidenttype',
  IncidentCategory = 'incidentcategory',
  Message = 'message',
  BusinessRule = 'businessrule',
  BusinessActivityLog = 'businessactivitylog',
  EventLog = 'eventlog',
  TimeRecordOfTeam = 'timerecord',
  TimeManager2Project = 'timemanager2project',
  TeamUsers = 'teamusers',
  Team = 'team',
  Team2User = 'team2user',
  TimeManager2Team = 'teamusers',
  Attachment = 'attachment',
  EntityType = 'entitytype',
  StatusLookup = 'statuslookup',
  TimeRecordStatus = 'timerecordstatus',
  SyncMaster = 'syncmaster',
  Users2Project = 'users2project',
  FormDefinition = 'formdefinition',
  FormDocuments = 'formdocuments',
  ChoiceDefinition = 'choicedefinition',
  DeviceIdAndDocumentIdSequence = 'deviceidanddocumentidseq',
  SyncActionQueue = 'syncactionqueue',
  NotableActivityOption = 'notableactivity',
  SyncParams = 'syncparams',
  FormDocumentMedia = 'formdocumentmedia',
  OdometerReading = 'odometerreading',
  OdometerReadingMedia = 'odometerreadingmedia',
}
